import SecondaryLayout from 'components/global/SecondaryLayout';
import SimpleCard from 'components/global/SimpleCard';
import { Button, Col, Image, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { $form } from 'signals/global.signals';
import UniversalInput from 'components/global/UniversalInput';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import ForgotPasswordModal from 'components/views/Login/_components/ForgotPasswordModal';
import withDismount from 'hocs/withDismount';
import { handleClickLogin } from './_helpers/login.events';

const Login = () => {
  const navigate = useNavigate();
  return (
    <SecondaryLayout>
      <SimpleCard className="text-white bg-gray-800 px-40">
        <Row className="my-32 border-bottom border-gray-700 pb-16">
          <Col xs={12} className="text-center">
            <Image
              className="nav-logo mb-16"
              src="/images/logo-lg.png"
              height="100%"
            />
            <h4 className="text-center">Log In</h4>
            <h5 className="text-center">Welcome back! Please log in to continue</h5>
          </Col>
        </Row>
        <Row className="my-32 border-bottom border-gray-700 pb-32">
          <Col>
            <UniversalInput
              name="email"
              value={$form.value.email}
              label="Email"
              className="mb-24"
              placeholder="Email"
            />
            <UniversalInput
              type="password"
              name="password"
              value={$form.value.password}
              label="Password"
              placeholder="Password"
              className="mb-48"
            />
            <Button
              onClick={() => handleClickLogin(navigate)}
              disabled={!$form.value.email || !$form.value.password}
              variant="primary"
              className="w-100 py-8"
            >
              {$form.value.isLoading
                ? <div className="spinner-border" />
                : 'Sign In'}
            </Button>
          </Col>
        </Row>
        <Row className="mb-32">
          <Col className="text-center">
            <div>Don&apos;t have an account?</div>
            <Button
              className="btn-text text-primary bg-transparent border-0 p-0 mb-4 ms-4"
              onClick={() => navigate('/signup')}
            >
              Sign Up
            </Button>
          </Col>
          <Col className="text-center">
            <div>Forgot your password?</div>
            <Button
              className="btn-text text-primary bg-transparent border-0 p-0 mb-4 ms-4"
              onClick={() => handleShowModal('forgot-password')}
            >
              Reset Password
            </Button>
          </Col>
        </Row>
      </SimpleCard>
      <ForgotPasswordModal />
    </SecondaryLayout>
  );
};

export default withDismount(Login);
